import { getFunctions } from 'firebase/functions';
import { firebaseApp } from './firebase';

export const firebaseFunctions = getFunctions(firebaseApp, 'us-central1');
